var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSatuatoryblack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "satuatoryblack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "satuatoryblack",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1, 1)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.00002,19.313735 L12.00002,21.313735 L0,21.313735 L0,19.313735 L12.00002,19.313735 Z M12.58582,4.4408921e-16 L20.36392,7.778175 L18.94972,9.192385 L17.88912,8.838835 L15.41422,11.313735 L21.07112,16.970535 L19.65682,18.384735 L14.00002,12.727935 L11.59582,15.132035 L11.87872,16.263435 L10.46442,17.677635 L2.68629,9.899535 L4.10051,8.485285 L5.23188,8.768125 L11.52512,2.474875 L11.17162,1.414215 L12.58582,4.4408921e-16 Z M13.29292,3.535535 L6.22183,10.606635 L9.75732,14.142135 L16.82842,7.071065 L13.29292,3.535535 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatuatoryblack);
export default __webpack_public_path__ + "static/media/satuatoryblack.f8d57b1475eb81c3070ad5d0712174b9.svg";
export { ForwardRef as ReactComponent };